export * from './szjh.component';